export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-Latin2-86c57595c1697937314b72d55a8c0353.woff";